document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, setting up Calendly popups...');
  
  // Warte bis Calendly geladen ist
  function waitForCalendly() {
    if (typeof Calendly !== 'undefined') {
      console.log('Calendly is loaded!');
      setupAllCalendlyLinks();
      setupCalendlyButtons();
    } else {
      console.log('Calendly not loaded yet, waiting...');
      setTimeout(waitForCalendly, 100);
    }
  }
  
  function setupAllCalendlyLinks() {
    // Finde alle Links, die zu Calendly führen
    var allLinks = document.querySelectorAll('a[href*="calendly.com"]');
    console.log('Found', allLinks.length, 'Calendly links');
    
    allLinks.forEach(function(link, index) {
      console.log('Setting up Calendly link', index, 'with URL:', link.href);
      
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var calendlyUrl = this.href;
        console.log('Calendly link clicked! URL:', calendlyUrl);
        
        if (calendlyUrl && calendlyUrl !== '') {
          try {
            if (typeof Calendly !== 'undefined') {
              Calendly.initPopupWidget({
                url: calendlyUrl,
                prefill: {},
                utm: {}
              });
              console.log('Calendly popup opened from link!');
            } else {
              console.log('Calendly not loaded, opening URL directly...');
              window.open(calendlyUrl, '_blank');
            }
          } catch (error) {
            console.error('Error opening Calendly:', error);
            window.open(calendlyUrl, '_blank');
          }
        }
      });
    });
  }
  
  function setupCalendlyButtons() {
    // Finde alle Buttons mit data-calendly-url
    var buttons = document.querySelectorAll('.open-calendly-btn');
    console.log('Found', buttons.length, 'Calendly buttons');
    
    buttons.forEach(function(btn, index) {
      console.log('Setting up button', index, 'with URL:', btn.getAttribute('data-calendly-url'));
      
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var calendlyUrl = this.getAttribute('data-calendly-url');
        console.log('Button clicked! URL:', calendlyUrl);
        
        if (calendlyUrl && calendlyUrl !== '') {
          try {
            if (typeof Calendly !== 'undefined') {
              Calendly.initPopupWidget({
                url: calendlyUrl,
                prefill: {},
                utm: {}
              });
              console.log('Calendly popup opened from button!');
            } else {
              console.log('Calendly not loaded, opening URL directly...');
              window.open(calendlyUrl, '_blank');
            }
          } catch (error) {
            console.error('Error opening Calendly:', error);
            window.open(calendlyUrl, '_blank');
          }
        } else {
          console.error('No Calendly URL found!');
        }
      });
    });
  }
  
  // Starte den Prozess
  waitForCalendly();
}); 